import Vue from 'vue';
import dayjs from 'dayjs';

/**
 * @param  {number} value 处理前的时间，单位是毫秒
 * @return {string} 参数值
 */
export default Vue.filter('timeYMDHM', function (value: number) {
    if (!value) {
        return '';
    }

    return dayjs(value).format('YYYY-MM-DD HH:mm');
});
